module.exports = __webpack_public_path__ + "img/parker-shelton-card.090bc377.webp";